import React from 'react';
import { ShieldCheck, Smartphone, Phone } from 'lucide-react';
import { tip } from '@/components/messages/ChatTooltip';

interface Props {
  /** Service name dal record api_configurations. */
  serviceName?: string | null;
  /** Size del badge. Default 'sm'. */
  size?: 'xs' | 'sm';
  /** Mostra solo l'icona (no label testuale). Utile per spazi stretti. */
  iconOnly?: boolean;
}

/**
 * Badge piccolo provider WhatsApp da mostrare accanto al nome contatto / nel header chat.
 *
 * Naming user-facing VINCOLANTE (regola plan): mai "WAHA"/"Cloud API"/"Coexistence".
 * Solo Standard / Ufficiale / Ufficiale + App.
 *
 * Per WAHA il badge è grigio neutro (l'utente non deve percepire WAHA come "inferiore"),
 * per Cloud verde verifica Meta. Per Coex verde + icona telefono.
 */
export function ProviderBadge({ serviceName, size = 'sm', iconOnly = false }: Props) {
  const cfg = resolveBadge(serviceName);
  if (!cfg) return null;

  const Icon = cfg.icon;
  const sizeCls = size === 'xs'
    ? 'text-[9px] px-1.5 py-0.5 gap-1'
    : 'text-[10px] px-2 py-0.5 gap-1';
  const iconSize = size === 'xs' ? 'h-2.5 w-2.5' : 'h-3 w-3';

  return (
    <span
      className={`inline-flex items-center font-semibold rounded-full ${sizeCls} ${cfg.bg}`}
      {...tip(cfg.tooltip)}
    >
      <Icon className={iconSize} />
      {!iconOnly && cfg.label}
    </span>
  );
}

interface BadgeCfg {
  label: string;
  bg: string;
  tooltip: string;
  icon: React.ComponentType<{ className?: string }>;
}

function resolveBadge(serviceName: string | null | undefined): BadgeCfg | null {
  switch (serviceName) {
    case 'waha':
      return {
        label: 'Standard',
        bg: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200',
        tooltip: 'Numero collegato con il QR: scrivi liberamente, senza modelli approvati da Meta',
        icon: Phone,
      };
    case 'whatsapp_cloud':
      return {
        label: 'Ufficiale',
        bg: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
        tooltip: 'Numero ufficiale verificato da Meta: se il contatto non scrive da 24 ore puoi mandare solo un modello approvato',
        icon: ShieldCheck,
      };
    case 'whatsapp_cloud_coex':
      return {
        label: 'Ufficiale + App',
        bg: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300',
        tooltip: 'Numero ufficiale verificato da Meta, attivo anche sull\'app WhatsApp Business del telefono',
        icon: Smartphone,
      };
    default:
      return null;
  }
}
